<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ded"> </p>
<p class="DED"><span class="ePub-B">T</span><span class="ePub-SC-B">O THE DEVOTED TEACHERS AND LIBRARIANS WHO HELP GUIDE US IN OUR QUEST FOR TRUTH</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?c85bcaca